import { Box } from "@mui/material";
import ReturningClientAddNewCard from "@/components/booking/steps/returningClientAddNewCard";
import PageContainer from "@/components/common/pageContainer/pageContainer";
import PageHeader from "@/components/common/pageHeader/pageHeader";
import { GREY } from "@/config/mui/colorPalette";
import { PublicStripeProvider } from "@/config/publicStripe";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { BookingStep } from "@/types/bookingTypes";

export default function BookingReturningClientEditCard() {
  const { setStep, medspaData } = useClientBookingContext();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: GREY[5],
        height: "100vh",
        width: "100vw",
        zIndex: 9999,
      }}
    >
      <PageContainer>
        <PageHeader
          title="Add new card"
          goBackStrategy="onClick"
          goBackOnClick={() => setStep(BookingStep.RETURNING_CLIENT)}
        />
        <PublicStripeProvider stripeAccountId={medspaData.stripeAccountId}>
          <ReturningClientAddNewCard />
        </PublicStripeProvider>
      </PageContainer>
    </Box>
  );
}
